import { render, staticRenderFns } from "./WidgetCredentials.vue?vue&type=template&id=f5a88380"
import script from "./WidgetCredentials.vue?vue&type=script&lang=js"
export * from "./WidgetCredentials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports